import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Pane, majorScale, minorScale } from 'evergreen-v4'

export default class NavigationBar extends PureComponent {
  static propTypes = {
    /**
     * Component to render in the center.
     * - Title
     * - Title breadcrumb
     */
    centerView: PropTypes.node,

    /**
     * Component to render on the left.
     * - Workspace dropdown
     * - Back button
     * - Cancel button
     */
    leftView: PropTypes.node,

    /**
     * Component to render on the right.
     * - Avatar dropdown
     */
    rightView: PropTypes.node,

    /**
     * Component to be rendered under the title bar.
     * - TabBar
     * - StepIndicatorBar
     */
    children: PropTypes.node
  }

  render() {
    const { children, centerView, rightView, leftView } = this.props
    return (
      <Pane background="white" elevation={0} zIndex={2}>
        <Pane display="flex" height={majorScale(7)}>
          <Pane
            flexBasis={majorScale(30)}
            display="flex"
            alignItems="center"
            paddingLeft={minorScale(3)}
          >
            {leftView}
          </Pane>
          <Pane
            className="fade-in-simple"
            flex={1}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            {centerView}
          </Pane>
          <Pane
            paddingRight={minorScale(3)}
            flexBasis={majorScale(30)}
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
          >
            {rightView}
          </Pane>
        </Pane>
        {children && (
          <Pane
            borderTop="muted"
            display="flex"
            justifyContent="center"
            paddingY={majorScale(1)}
          >
            {children}
          </Pane>
        )}
      </Pane>
    )
  }
}
